module.exports = __webpack_public_path__ + "ci_slack.4ac3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_slack.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_slack.svg
// module chunks = main